import React, { useEffect, useState } from "react";
import "../../../assets/css/home.css";
import logo from "../../../assets/images/logo-new.png";
import franchise from "../../../assets/images/ariha_ franchise.pdf";
import catelog from "../../../assets/images/ariha_catlg.pdf";
import { Row, Col, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CiMail } from "react-icons/ci";
import { LuPhone, LuMapPin } from "react-icons/lu";
import { MdOutlineFileDownload } from "react-icons/md";
import PostApiCall from "../helper/PostAPI";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

function Footer() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    PostApiCall.postRequest(
      {
        catCount: "*",

        // whereClause: "",
        // columns: "*",
      },
      "GetProductVertical"
      // "getCategoryDetails"
    ).then((results) =>
      results?.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setCategories(
            obj1.data.filter((dat) => dat.fld_status === "Active")
            // obj1.data.filter((dat) => dat.fld_enabled_flag === "Yes")
          );
        }
      })
    );
  }, []);
  const date = new Date();

  return (
    <>
      <div className="footer py-5">
        <Container>
          <Row className="d-flex">
            {/* Logo and Description */}
            <Col
              xs={12}
              md={4}
              className="text-center text-md-start mb-4 mb-md-0">
              <img src={logo} className="pb-3" alt="logo" width="100px" />
              <p>
                Ariha Foods delivers honest, wholesome bakery products crafted
                with care—offering everything from fluffy buns to decadent
                brownies, all made fresh with vegetarian ingredients and zero
                compromises.
              </p>
              <div className="d-flex flex-column flex-md-row gap-2 justify-content-center justify-content-md-start">
                <Button className="yellowbutton">
                  <a href={franchise}>
                    <MdOutlineFileDownload className="me-2" />
                    Be Our Franchisee
                  </a>
                </Button>
                <Button className="yellowbutton">
                  <a href={catelog}>
                    <MdOutlineFileDownload className="me-2" />
                    Download Brochure
                  </a>
                </Button>
              </div>
            </Col>

            {/* Quick Links */}
            <Col
              xs={12}
              md={2}
              className="text-center text-md-start mb-4 mb-md-0">
              <h5 className="fw-semibold pb-2 text-uppercase">Quick Links</h5>
              <p>
                <Link to="/">Home</Link>
              </p>
              <p>
                <Link to="/shop">Shop</Link>
              </p>
              <p>
                <Link to="/about">About Us</Link>
              </p>
              <p>
                <Link to="/contact">Contact Us</Link>
              </p>
            </Col>

            {/* Categories */}
            <Col
              xs={12}
              md={2}
              className="text-center text-md-start mb-4 mb-md-0">
              <h5 className="fw-semibold pb-2 text-uppercase">Categories</h5>
              {categories.length > 0 ? (
                categories.slice(0, 6).map((cat) => (
                  <p key={cat.fld_verticleid}>
                    <Link to={`/category/${cat?.fld_route}`}>
                      {cat.fld_verticlename}
                    </Link>
                  </p>
                ))
              ) : (
                <p>Loading...</p>
              )}
            </Col>

            {/* Get in Touch */}
            <Col xs={12} md={4} className="text-center text-md-start">
              <h5 className="fw-semibold pb-2 text-uppercase">Get in Touch</h5>
              <div className="d-flex justify-content-center justify-content-md-start pb-2">
                <div>
                  <LuPhone size={24} className="me-2" />
                </div>
                <div>
                  <a href={`tel:+91-98844-55605`}>+91-98844-55605 /</a>/
                  <a href="tel:9841045605">+91-98410-45605</a>/
                  <a href="tel:8939744331">+91-8939-744331</a>
                </div>
              </div>
              <div className="d-flex justify-content-center justify-content-md-start pb-2">
                <a href={`mailto:wecare@arihafoods.com`}>
                  <CiMail size={24} className="me-2" /> wecare@arihafoods.com
                </a>
              </div>
              <div className="d-flex justify-content-center justify-content-md-start pb-2 text-center text-md-start">
                <LuMapPin size={24} className="me-2" />
                MIG 156B, 6th Main Rd,
                <br />
                West, Nolambur, Mogappair, <br />
                Chennai, Tamil Nadu, 600037
              </div>

              <div className="d-flex gap-3 justify-content-center justify-content-md-start pt-2">
                <a
                  href="https://www.facebook.com/arihafoods/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white">
                  <FaFacebookF size={20} />
                </a>
                <a
                  href="https://www.instagram.com/ariha_foods/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white">
                  <FaInstagram size={20} />
                </a>
                <a
                  href="https://in.linkedin.com/company/arihafoods-private-limited"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white">
                  <FaLinkedinIn size={20} />
                </a>
                <a
                  href="https://www.youtube.com/@arihafoods"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white">
                  <FaYoutube size={20} />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div
        className="footer_bottom mx-5 text-center py-3 mb-md-0 d-flex justify-content-between"
        style={{ marginBottom: "80px" }}>
        <span>Designed By Global Trendz</span>
        <span>
          {" "}
          © Copyright {date?.getFullYear()} Ariha Foods Pvt Ltd. All rights
          reserved
        </span>
      </div>
    </>
  );
}

export default Footer;
